const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const extractRepoPath = (url: string, provider?: string, authUrl?: string) => {
  if (provider === 'github') {
    const match = url.match(/(.+?)github\.com[:\/](.+?)(\.git)?$/i);
    if (match != null) {
      return match[2];
    }
    return '';
  }

  if (provider === 'bitbucket') {
    const match = url.match(/(.+?)bitbucket\.org[:\/](.+?)(\.git)?$/i);
    if (match != null) {
      return match[2];
    }
    return '';
  }

  const hostFromAuth = authUrl?.replace(/^https?:\/\//i, '').replace(/\/$/, '');
  if (hostFromAuth) {
    const match = url.match(
      new RegExp(`(.+?)${escapeRegExp(hostFromAuth)}[:\\/](.+?)(\\.git)?$`, 'i')
    );
    if (match != null) {
      return match[2];
    }
  }

  const glMatch = url.match(/(.+?)gitlab\.com[:\/](.+?)(\.git)?$/i);
  if (glMatch != null) {
    return glMatch[2];
  }
  return '';
};

export default extractRepoPath;
